import EmblaCarousel from '@/components/EmblaCarousel';
import { useIsMobile } from '@/hooks/use-is-mobile';
import Image from 'next/image';
export const WarrantyRegisteration = () => {
  const { isMobile } = useIsMobile();
  const slides = [
    {
      title: 'Authorized Channels Only',
      description:
        'The Lifetime Warranty applies exclusively to HISEA boots and waders purchased through our authorized sales channels.',
    },
    {
      title: 'Normal Use',
      description:
        'The warranty covers defects arising from normal, intended use. It does not cover excessive damage caused by misuse or extreme activities.',
    },
    {
      title: 'Replacements',
      description:
        'If a product is replaced under warranty, the replacement will remain covered by the same Lifetime Warranty as the original.',
    },
    {
      title: 'Refund',
      description:
        'If the order is fully refunded, the warranty will be void and the product will no longer be covered.',
    },
    {
      title: 'Time for Claims',
      description: 'Claims must be submitted within a reasonable time after you discover the defect.',
    },
  ];
  const OPTIONS = {
    containScroll: false,
    align: 'start',
  };
  return (
    <div className=' personalContent mx-auto mb-[40px] px-[12px] lg_mb-[80px] lg_px-0'>
      <h2
        id='restrictions'
        className='mb-[10px] text-left font-teko-medium text-[30px] uppercase leading-[28px] lg_text-[40px] lg_leading-[48px]'
      >
        Warranty Restrictions
      </h2>

      <p className='mb-[20px] font-roboto-regular text-[16px] font-normal leading-[24px] lg_text-[18px] lg_leading-[30px]'>
        To keep the Lifetime Warranty fair and efficient, we have a few restrictions in place:
      </p>
      {isMobile ? (
        <div className='w-full pb-[20px] pl-[12px]'>
          <EmblaCarousel
            slides={slides}
            options={OPTIONS}
            classes={{
              emblaSlide: 'flex-[0_0_300px] mr-[10px]',
              emblaControls: 'hidden',
            }}
          >
            {(item, index) => (
              <div
                className='flex flex-col items-center justify-center bg-[#F9F9F9] px-[12px] py-[20px]'
                key={item.title}
              >
                <Image
                  src={`/warranty-page/icon${index + 1}.svg`}
                  width={40}
                  height={40}
                  alt={item.title}
                  className='h-[40px] w-[40px]'
                />
                <p className='mb-[10px] font-roboto-medium text-[18px] font-normal leading-[24px]'>{item.title}</p>
                <p className='font-roboto-light text-[16px] font-light leading-[26px]'>{item.description}</p>
                {item.title === 'Authorized Channels Only' && (
                  <p className='font-roboto-regular text-[16px] font-normal italic leading-[26px]'>
                    Please note: Orders placed on Temu are not eligible for warranty coverage.
                  </p>
                )}
              </div>
            )}
          </EmblaCarousel>
        </div>
      ) : (
        <div className='border-t-1 border-[#E0E0E0]'>
          {slides.map((item, index) => {
            return (
              <div
                className='align-start flex justify-start gap-[30px] border-b-1 border-[#E0E0E0] py-[20px]'
                key={item.title}
              >
                <Image
                  src={`/warranty-page/icon${index + 1}.svg`}
                  width={40}
                  height={40}
                  alt={item.title}
                  className='h-[40px] w-[40px]'
                />
                <div className=''>
                  <p className='mb-[10px] font-roboto-medium text-[20px] leading-[28px]'>{item.title}</p>
                  <p className='font-roboto-light text-[16px] font-light leading-[26px]'>{item.description}</p>
                  {item.title === 'Authorized Channels Only' && (
                    <p className='font-roboto-regular text-[16px] font-normal italic leading-[26px]'>
                      Please note: Orders placed on Temu are not eligible for warranty.
                    </p>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
